<div class="row mb-4">
	<strong class="h4">Billing</strong>
	<small class="text-muted mb-2">Revenue • invoices • credits</small>
	<div class="col-md-3">
		<div class="card card-animate card-green">
			<div class="card-body">
				<p class="text-muted mb-0">YTD REVENUE</p>
				<h4>{{ formatCurrency(report?.ytd_revenue) }}</h4>
				<small class="text-muted">{{ getDateRange() }}</small>
			</div>
		</div>
	</div>
	<div class="col-md-3">
		<div class="card card-animate card-blue">
			<div class="card-body">
				<p class="text-muted mb-0">This Week</p>
				<h4>{{ formatCurrency(report?.this_week) }}</h4>
				<small class="text-muted">Monday only</small>
			</div>
		</div>
	</div>
	<div class="col-md-3">
		<div class="card card-animate card-green">
			<div class="card-body">
				<p class="text-muted mb-0">Avg/Week</p>
				<h4>{{ formatCurrency(report?.avg_last_8_weeks) }}</h4>
				<small class="text-muted">8-week avg</small>
			</div>
		</div>
	</div>
	<div class="col-md-3">
		<div class="card card-animate card-red">
			<div class="card-body">
				<p class="text-muted mb-0">Open Invoices</p>
				<h4 class="text-danger">{{ report?.pending_leads }}</h4>
				<small class="text-muted">awaiting payment</small>
			</div>
		</div>
	</div>
</div>

<div class="card">
	<div class="card-header">
		<ul class="nav nav-tabs card-header-tabs" role="tablist">
			<li class="nav-item">
				<button class="nav-link" [class.active]="activeTab === 'charge'" (click)="activeTab = 'charge'"
					type="button">Charge</button>
			</li>
			<li class="nav-item">
				<button class="nav-link" [class.active]="activeTab === 'invoices'" (click)="activeTab = 'invoices'"
					type="button">Recent Invoices</button>
			</li>
			<li class="nav-item">
				<button class="nav-link" [class.active]="activeTab === 'revenue'" (click)="activeTab = 'revenue'"
					type="button">Campaign Revenue</button>
			</li>
		</ul>
	</div>

	<div class="card-body">
		<div *ngIf="activeTab === 'charge'">
			<app-billing-authorize [stripe_back]="''" [alertedIn]="true"></app-billing-authorize>
		</div>

		<div *ngIf="activeTab === 'invoices'">
			<div class="col-md-3 mb-3">
				<label>Date Range</label>
				<app-form-range-date [(ngModel)]="dateRangeInvoices_" (OnSelected)="dateSelectedInvoices($event)"
					[position]="'right'" [range_type]="'RANGE_PAST'" [autoApply]="true"></app-form-range-date>
			</div>

			<div class="table-responsive">
				<table class="table table-striped mb-0">
					<thead class="table-light">
						<tr>
							<th>Invoice</th>
							<th>Campaign / Client</th>
							<th>Payment Date / Week</th>
							<th>Description</th>
							<th>Amount</th>
							<th>Status</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let invoice of weeklyInvoices | slice: (page - 1) * pageSize : page * pageSize">
							<td>#{{ invoice.invoice }}</td>

							<td>
								<div class="fw-semibold">{{ invoice.name }}</div>
								<small class="text-muted">{{ invoice.client }}</small>
							</td>
							<td>
								<div class="fw-semibold">{{ invoice.payment_date | utcToLocal }}</div>
								<small class="text-muted">{{ weekLabel }}</small>
							</td>
							<td>{{ invoice.description }}</td>
							<td>${{ invoice.amount | number: "1.2-2" }}</td>
							<td>
								<span class="badge bg-success">
									{{ invoice.status | titlecase }}
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="d-flex justify-content-between align-items-center mt-2"
				*ngIf="weeklyInvoices.length > pageSize">
				<small class="text-muted"> Mostrando {{ (page - 1) * pageSize + 1 }}-{{ Math.min(page * pageSize,
					weeklyInvoices.length) }} de {{ weeklyInvoices.length }} </small>

				<nav>
					<ul class="pagination pagination-sm mb-0">
						<li class="page-item" [class.disabled]="page === 1">
							<button class="page-link" (click)="goToPage(page - 1)">Anterior</button>
						</li>
						<li class="page-item" *ngFor="let p of totalPagesArray" [class.active]="p === page">
							<button class="page-link" (click)="goToPage(p)">{{ p }}</button>
						</li>
						<li class="page-item" [class.disabled]="page === totalPages">
							<button class="page-link" (click)="goToPage(page + 1)">Siguiente</button>
						</li>
					</ul>
				</nav>
			</div>
		</div>

		<div *ngIf="activeTab === 'revenue'">
			<div class="d-flex justify-content-between align-items-end">
				<div class="col-md-3">
					<label>Date Range</label>
					<app-form-range-date [(ngModel)]="dateRange_" (OnSelected)="dateSelected($event)"
						[position]="'right'" [range_type]="'RANGE_PAST'" [autoApply]="true"></app-form-range-date>
				</div>

				<div class="btn-group" role="group">
					<input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off"
						[checked]="campaignTab === 'active'" (click)="toggleCampaignList('active')" />
					<label class="btn btn-outline-secondary" for="btnradio1">Active ({{ activeCount }})</label>

					<input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off"
						[checked]="campaignTab === 'inactive'" (click)="toggleCampaignList('inactive')" />
					<label class="btn btn-outline-secondary" for="btnradio2">Inactive ({{ inactiveCount }})</label>
				</div>
			</div>

			<div *ngIf="campaignList.length === 0" class="text-muted p-3">No hay campañas en el rango seleccionado.
			</div>

			<div class="table-responsive" *ngIf="campaignList.length > 0">
				<table class="cc-table-revenue">
					<thead>
						<tr>
							<th class="col-campaign">Campaign</th>
							<th class="text-center">Total Leads</th>
							<th class="text-center">Replaced Leads</th>
							<th class="text-center">Leads Billed</th>
							<th class="text-center">Revenue</th>
							<th class="text-center">Avg $/Lead</th>
							<th class="text-center">% of Total Revenue</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of filteredCampaigns; let i = index">
							<td class="col-campaign">{{ row.name }}</td>
							<td class="text-center">{{ row.total_leads }}</td>
							<td class="text-center">{{ row.replaced_leads | nullToDash }}</td>
							<td class="text-center">{{ row.billead_leads | nullToDash }}</td>
							<td class="text-center">{{ formatCurrency(row.Revenue | nullToDash) }}</td>
							<td class="text-center">
								{{ row.billead_leads > 0 ? "$" + (row.Revenue / row.billead_leads | number: "1.2-2") :
								"-" }}
							</td>
							<td class="text-center">
								{{ row.pct_total_revenue ? (row.pct_total_revenue | number: "1.1-1") + "%" : "-" }}
							</td>
						</tr>
					</tbody>
					<tfoot>
						<tr class="cc-table-revenue-totals">
							<td>Totals</td>
							<td class="text-center">{{ getTotal("total_leads") }}</td>
							<td class="text-center">{{ getTotal("replaced_leads") | nullToDash }}</td>
							<td class="text-center">{{ getTotal("billead_leads") | nullToDash }}</td>
							<td class="text-center">{{ formatCurrency(getTotal("Revenue")) | nullToDash }}</td>
							<td class="text-center">{{ getGlobalAvgPerLead() | nullToDash }}</td>
							<td class="text-center">-</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>
</div>
